

















import { Component, Prop, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import { DxNavBar } from 'devextreme-vue';
import {
  TunnelGroup,
  ITunnelGroup,
  RawMaterialGroupsClient,
  IRawMaterialGroup,
  UpdateRawMaterialGroupCommand,
  RawMaterialGroupTunnelGroup,
  DeleteRawMaterialGroupCommand,
} from '@/data/web-api-client';
import DataSource from 'devextreme/data/data_source';
import AddRawMaterialGroupsDialog from './AddRawMaterialGroupsDialog.vue';

@Component({
  components: {
    Datagrid,
    AddRawMaterialGroupsDialog,
    DxNavBar,
  },
})
export default class RawMaterialGroupsTable extends Vue {
  @Prop({ required: true })
  tunnelGroups: any;

  public loading = false;
  showDialog: boolean = false;

  private rawMaterialGroupsClient: RawMaterialGroupsClient = new RawMaterialGroupsClient(undefined, this.$axios);

  private created() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.loading = true;
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  get groupingConfig() {
    return {
      autoExpandAll: false,
      expandMode: 'rowClick',
    };
  }

  public datasource: DataSource = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        (loadOptions as any).stringToLower = true;

        const result: any[] = await this.rawMaterialGroupsClient.getAll();

        for (const rawMaterialGroup of result) {
          if (!rawMaterialGroup?.tunnelGroups! || rawMaterialGroup?.tunnelGroups!.length <= 0) {
            continue;
          }

          for (const tunnelGroup of rawMaterialGroup!.tunnelGroups!) {
            const matchedTunnelGroup: TunnelGroup = this.tunnelGroups.find((tg: TunnelGroup) => tg.id == tunnelGroup.id);

            if (matchedTunnelGroup) {
              rawMaterialGroup[`${matchedTunnelGroup!.name!}`] = tunnelGroup.discountValue;
            }
          }
        }

        return {
          data: result,
          totalCount: result.length,
        };
      },
      remove: async (id: any) => {
        try {
          await this.rawMaterialGroupsClient.deleteRawMaterialGroup({ rawMaterialGroupId: id } as DeleteRawMaterialGroupCommand);
          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
      update: async (id: any) => {
        try {
          const row = this.gridInstance.getVisibleRows().find((r: any) => r.key == id);

          if (!row) {
            return;
          }

          const rawMaterialGroup = row.data;

          const tunnelGroupValues: RawMaterialGroupTunnelGroup[] = [];

          for (const tunnelGroup of this.tunnelGroups) {
            if (!rawMaterialGroup.hasOwnProperty(tunnelGroup.name)) continue;
            tunnelGroupValues.push({
              id: tunnelGroup.id,
              discountValue: rawMaterialGroup[tunnelGroup.name],
            } as RawMaterialGroupTunnelGroup);
          }

          await this.rawMaterialGroupsClient.updateRawMaterialGroup({
            id: rawMaterialGroup.id,
            name: rawMaterialGroup.name,
            margin: rawMaterialGroup.margin,
            tunnelGroups: tunnelGroupValues,
          } as UpdateRawMaterialGroupCommand);

          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
    }),
    paginate: true,
  });

  refresh() {
    this.showDialog = false;

    try {
      this.gridInstance.refresh();
      this.$emit('refresh');
    } catch {
      notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
    }
  }

  private addRawMaterialGroups() {
    this.showDialog = true;
  }

  get columns() {
    const self = this;
    let columns: any[] = [
      {
        dataField: 'name',
        caption: 'Naam',
        allowEditing: false,
      },
    ];
    const tunnelGroupColumns = [];

    for (const tunnelGroup of this.tunnelGroups as ITunnelGroup[]) {
      tunnelGroupColumns.push({
        dataField: tunnelGroup.name,
        caption: tunnelGroup.name,
      });
    }

    const buttonsColumn = {
      type: 'buttons',
      buttons: ['edit', 'delete'],
    };

    columns = [...columns, ...tunnelGroupColumns];

    columns.push(buttonsColumn);
    return columns;
  }

  get toolbarOptions() {
    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: this.addRawMaterialGroups,
        },
      },
    ];
  }

  get gridInstance() {
    return ((this.$refs.grid as Vue).$refs.RawMaterialGroupsGrid as any).instance;
  }
}
